import { Accordion as PrimeAccordion, AccordionTab as PrimeAccordionTab } from 'primereact/accordion'
export const Accordion = PrimeAccordion
export const AccordionTab = PrimeAccordionTab
